import { Action, ThunkAction, configureStore } from '@reduxjs/toolkit';
import {
    createMigrate,
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from 'redux-persist';
import storage from 'redux-persist-indexeddb-storage';
import rootReducer from './reducers';
import { migrations } from './helpers/migrations';

const persistConfig = {
    key: 'root',
    version: 0,
    storage: storage('lumio'),
    whitelist: ['filters', 'ratings', 'classes', 'students', 'favourites'],
    // Upgrade db schema if version changes
    //@ts-ignore
    migrate: createMigrate(migrations, { debug: false }),
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER], //ignore redux-persist actions
      },
    }),
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;